import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function AdvantagesSection({ element }) {
  const [active, setActive] = useState(0);

  // Кожні 3 секунди змінюємо активний елемент
  useEffect(() => {
    if (!element?.advantages?.length) return;

    const interval = setInterval(() => {
      setActive((prev) =>
        prev === element.advantages.length - 1 ? 0 : prev + 1,
      );
    }, 1500);

    return () => clearInterval(interval);
  }, [element?.advantages?.length]);

  return (
    <section className={`layout__color_primary position-relative `}>
      <Container fluid>
        <Row>
          <Col md={12} lg={7} xl={6} className="mb-5 mb-xl-0">
            <h2 data-aos="fade-up">{element.title}</h2>
          </Col>
          <Col xs={12} md={10} lg={5} xl={5} className="offset-xl-1">
            {element.intro && (
              <p className="layout_text layout_text__medium" data-aos="fade-up">
                {element.intro}
              </p>
            )}
          </Col>
          {element.advantages && (
            <Col xs={12} className="layout_mt_new">
              <Row className="align-items-stretch justify-content-center gap-y-20">
                {element.advantages.map((item, index) => {
                  return (
                    <Col
                      xs={12}
                      md={6}
                      xxl={4}
                      key={index}
                      className="h-auto"
                      data-aos="fade-up"
                    >
                      <div
                        className={`advantages_item h-100 d-flex flex-column ${active === index ? "layout__bg layout__bg_primary" : ""}`}
                      >
                        <h3 className="layout_text layout_text__medium fw-400 mb-3">
                          {item.title}
                        </h3>
                        <p className="layout_text">{item.description}</p>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  );
}
